import React, { PureComponent } from 'react';
import { LoadClassification } from '../../../../../model/CORE';
import { MonitoredLoadBar, MonitoredLoadBarProps } from './MonitoredLoadBar';
import Utils from 'app/common/util/Utils';

interface OccupancyLoadBarProps extends Omit<MonitoredLoadBarProps, 'fillColor'> {}

export class OccupancyLoadBar extends PureComponent<OccupancyLoadBarProps> {
    getFillColor = (loadClassification: LoadClassification, nonRelevant?: boolean): string => {
        switch (loadClassification) {
            case LoadClassification.NORMAL:
                return nonRelevant ? 'url(#normal-hashed)' : 'url(#normal)';
            case LoadClassification.LOW_THRESHOLD:
                return nonRelevant ? 'url(#low-threshold-hashed)' : 'url(#low-threshold)';
            case LoadClassification.HIGH_THRESHOLD:
                return nonRelevant ? 'url(#high-threshold-hashed)' : 'url(#high-threshold)';
            case LoadClassification.OVERLOAD:
                return nonRelevant ? 'url(#overload-hashed)' : 'url(#overload)';
            case LoadClassification.UNDEFINED:
            default:
                return '#262626';
        }
    };

    render() {
        let { label, ...otherProps } = this.props;

        if (Utils.isNotExists(label)) {
            label = 'O';
        }

        return <MonitoredLoadBar label={label} fillColor={this.getFillColor} {...otherProps} />;
    }
}
